const tryParse =  function(obj){
  if(typeof obj==='string'){
    let time=obj.replace(/-/g,"/");
    return new Date(obj);
  }else{
    return obj;
  }
}

/**
 * 是否是同一天
 * @param {*} one
 * @param {*} two
 */
export function isSameDay(one, two){
  const oneDate = tryParse(one)
  const twoDate = tryParse(two)
  return (
    oneDate.getDate() === twoDate.getDate() &&
    oneDate.getMonth() === twoDate.getMonth() &&
    oneDate.getFullYear() === twoDate.getFullYear()
  )
}



// WEBPACK FOOTER //
// ./src/common/js/calendar.js